import colors from "assets/colors";

export type AnalysisPayload = {
  data: {
    pred: {
      all?: Analysis;
      cat_N?: Analysis;
      cat_M?: Analysis;
      cat_S?: Analysis;
      cat_A?: Analysis;
      cat_D?: Analysis;
      user?: UserAnalysis;
    };
    results: {
      all?: Analysis;
      cat_N?: Analysis;
      cat_M?: Analysis;
      cat_S?: Analysis;
      cat_A?: Analysis;
      cat_D?: Analysis;
      user?: UserAnalysis;
    };
  };
};

export type Analysis = {
  最高: {
    // max
    [dateKey: string]: number;
  };
  最低: {
    // min
    [dateKey: string]: number;
  };
  中位數: {
    [dateKey: string]: number;
  };
  平均: {
    // avg
    [dateKey: string]: number;
  };
  下四分位: {
    // lq
    [dateKey: string]: number;
  };
  上四分位: {
    // uq
    [dateKey: string]: number;
  };
  學生: {
    // user
    [dateKey: string]: number;
  };
};

export enum ANALYSIS {
  MAX = "最高",
  MIN = "最低",
  MEDIAN = "中位數",
  MEAN = "平均",
  LQ = "下四分位",
  UQ = "上四分位",
  USER = "學生",
}

export type UserAnalysis = {
  平均表現?: {
    [dateKey: string]: number;
  };
  數?: {
    [dateKey: string]: number;
  };
  度量?: {
    [dateKey: string]: number;
  };
  圖形與空間?: {
    [dateKey: string]: number;
  };
  代數?: {
    [dateKey: string]: number;
  };
  數據處理?: {
    [dateKey: string]: number;
  };
};

export enum USERANALYSIS {
  AVRG = "平均表現",
  MATH = "數",
  MEAS = "度量",
  GEOM = "圖形與空間",
  ALGE = "代數",
  DATA = "數據處理",
}

export const ANALYSIS_COLOR_KEYS = {
  [ANALYSIS.MAX]: colors.distinct[0],
  [ANALYSIS.MIN]: colors.distinct[1],
  [ANALYSIS.MEDIAN]: colors.distinct[6],
  [ANALYSIS.MEAN]: colors.distinct[2],
  [ANALYSIS.LQ]: colors.distinct[4],
  [ANALYSIS.UQ]: colors.distinct[3],
  [ANALYSIS.USER]: colors.distinct[5],
  [USERANALYSIS.AVRG]: colors.distinct[5],
  [USERANALYSIS.MATH]: colors.distinct[0],
  [USERANALYSIS.MEAS]: colors.distinct[1],
  [USERANALYSIS.GEOM]: colors.distinct[2],
  [USERANALYSIS.ALGE]: colors.distinct[3],
  [USERANALYSIS.DATA]: colors.distinct[4],
};
